import { IPlanChuongTrinhDaoTaoKienThuc } from "../../../model/respone/category/IPlanChuongTrinhDaoTaoKienThuc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuongTrinhDaoTaoKienThucActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPlanChuongTrinhDaoTaoKienThuc[],
  LOAD_ERRR: "",
};
export const eChuongTrinhDaoTaoKienThucIds = generateActionTypeIds(
  eChuongTrinhDaoTaoKienThucActionsObj,
  "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
);
export type IChuongTrinhDaoTaoKienThucActionTypes = IGenericActionType<
  typeof eChuongTrinhDaoTaoKienThucActionsObj,
  "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
>;
